// extracted by mini-css-extract-plugin
export var chip = "slider-module--chip--k3vCR";
export var chipActive = "slider-module--chip-active--uAbnS";
export var input = "slider-module--input--DfthW";
export var item = "slider-module--item--A2PpP";
export var left = "slider-module--left--1Nohx";
export var menu = "slider-module--menu--iIvbv";
export var wrapperItemInner = "slider-module--wrapper-item-inner--G1O2S";
export var wrapperItemOuter = "slider-module--wrapper-item-outer--l6qbb";